module.exports = __webpack_public_path__ + "static/media/ZT5.2b1482e0.jpg";